import { Link as ReactLink } from "expo-router";
import React, { useState } from "react";

import { Text } from "./text";

import { Pressable } from "react-native";

type LinkProps = {
	href: string;
	children?: React.ReactNode;
	fontWeight?: string;
	fontSize?: any;
	onPress?: () => void;
	onHoverIn?: () => void;
	onHoverOut?: () => void;
	component?: (hovered: boolean) => React.ReactNode;
	isFluid?: boolean;
	width?: string;
	pressableStyle?: any;
	target?: string;
};

const Link: React.FC<LinkProps> = ({ href, pressableStyle, isFluid, onHoverOut, children, fontWeight, fontSize, onPress, onHoverIn, component, width, target = null }) => {
	const [hovered, setHovered] = useState(false);
	const [isPressed, setIsPressed] = useState(false);
	return (
		// @ts-ignore
		<ReactLink href={href} asChild style={{ opacity: isPressed ? 0.5 : 1, width: width, flex: isFluid && 1 }}>
			<Pressable
				onHoverIn={() => {
					setHovered(true);
					if (onHoverIn) {
						onHoverIn();
					}
				}}
				style={pressableStyle}
				onHoverOut={() => {
					setHovered(false);
					if (onHoverOut) {
						onHoverOut();
					}
				}}
				onPress={onPress}
				onPressIn={() => setIsPressed(true)}
				onPressOut={() => setIsPressed(false)}
			>
				{component ? (
					component(hovered)
				) : typeof children === "string" ? (
					<Text
						alignItems="center"
						gap={6}
						fontWeight={fontWeight == "" ? "$normal" : fontWeight}
						sx={{
							display: "flex",
							color: hovered ? "$primary" : "$textLight700",
							fontFamily: "$body",
							fontSize: fontSize ? fontSize : "$linkdefaultdesktop",
						}}
					>
						{children}
					</Text>
				) : (
					children
				)}
			</Pressable>
		</ReactLink>
	);
};

export default Link;
